export const actions = {
  async sendMessage ({}, payload) {
    return await this.$axios.post('/contact/send', payload)
  }
}
